"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var integer_schema_1 = __importDefault(require("./integer.schema"));
exports["default"] = integer_schema_1["default"];
//# sourceMappingURL=index.js.map